import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    ClientInterface,
    ContractInterface,
    DisinvestmentInterface,
    FeeInterface,
    FileInterface,
    IdInterface,
    OrderClientInterface,
    TransferInterface,
    ValidModelInterface,
} from '../data';
import { ContractCacheRepository } from '../repositories/contract-cache.repository';
import { Transaction } from '../transaction/transaction';
import { TransferApiRepository } from '../repositories/transfer-api.repository';

@Injectable()
export class TransferProvider {
    constructor(private transferRepository: TransferApiRepository, private contractCacheRepository: ContractCacheRepository) {}

    evaluateFee(contractCode: IdInterface, fee: FeeInterface): Observable<Transaction<number>> {
        return this.transferRepository.evaluateFee(contractCode, fee);
    }

    getModelPdf(id: IdInterface): Observable<Transaction<FileInterface>> {
        return this.transferRepository.getModelPdf(id);
    }

    getValidModels(contract: ContractInterface, client: ClientInterface): Observable<Transaction<ValidModelInterface[]>> {
        return this.transferRepository.getValidModels(contract, client);
    }

    setFee(contractCode: IdInterface, fee: FeeInterface): Observable<Transaction<boolean>> {
        return this.transferRepository.setFee(contractCode, fee);
    }

    setTransfer(transfer: TransferInterface): Observable<Transaction<boolean>> {
        return this.transferRepository.setTransfer(transfer).pipe(
            tap((transaction) => {
                if (transaction.isSuccess) {
                    this.contractCacheRepository.clear().subscribe();
                }
            })
        );
    }

    signDisinvestment(
        contractCode: IdInterface,
        signatories: OrderClientInterface[],
        investment: DisinvestmentInterface
    ): Observable<Transaction<boolean>> {
        return this.transferRepository.signDisinvestment(contractCode, signatories, investment);
    }

    signModel(contractCode: IdInterface, signatories: OrderClientInterface[], modelId: IdInterface): Observable<Transaction<boolean>> {
        return this.transferRepository.signModel(contractCode, signatories, modelId);
    }

    signTransfer(
        contractCode: IdInterface,
        signatories: OrderClientInterface[],
        transfer: TransferInterface
    ): Observable<Transaction<boolean>> {
        return this.transferRepository.signTransfer(contractCode, signatories, transfer);
    }
}
